module.exports = __webpack_public_path__ + "assets/img/0528bc3a94b405799cbbf8048a2fff94.png";